export const months = [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro',
];

export const short_months = [
    'Jan',
    'Fev',
    'Mar',
    'Abr',
    'Mai',
    'Jun',
    'Jul',
    'Ago',
    'Set',
    'Out',
    'Nov',
    'Dez'
];


export const days =  [
    {
        number: 1,
        text: 'Domingo',
    }, {
        number: 2,
        text: 'Segunda',
    }, {
        number: 3,
        text: 'Terça',
    }, {
        number: 4,
        text: 'Quarta',
    }, {
        number: 5,
        text: 'Quinta',
    }, {
        number: 6,
        text: 'Sexta',
    }, {
        number: 7,
        text: 'Sábado',
    },
]
